export default {
    oauthUser: {
        sbmUserId: null,
        email: null,
        name: null
    },
    user: null,
    pendingUsers: [],
    rejectedUsers: [],
}



// WEBPACK FOOTER //
// ./src/redux/reducers/users/init.js